import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  IconButton,
  Box,
  Tooltip,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Close, ContentCopy } from '@mui/icons-material';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-sh';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/theme-monokai';

function ApiCurlExpandedDialog({ open, onClose, curlCommand }) {
  const theme = useTheme();
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(curlCommand);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          height: '80vh',
          maxHeight: '80vh',
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">API Endpoint - cURL Command</Typography>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              Copy the command below to trigger your workflow via API
            </Typography>
            <Tooltip title={copySuccess ? 'Copied!' : 'Copy to clipboard'}>
              <Button
                variant="outlined"
                size="small"
                startIcon={<ContentCopy />}
                onClick={handleCopy}
                sx={{
                  color: copySuccess ? 'success.main' : 'primary.main',
                  borderColor: copySuccess ? 'success.main' : 'primary.main',
                }}
              >
                {copySuccess ? 'Copied!' : 'Copy'}
              </Button>
            </Tooltip>
          </Box>
        </Box>

        <Box sx={{ flex: 1, minHeight: 0 }}>
          <div id="aceditor" style={{ width: '100%', height: '100%' }}>
            <AceEditor
              mode="sh"
              theme={theme.palette.mode === 'dark' ? 'monokai' : 'github'}
              width="100%"
              height="100%"
              showPrintMargin={false}
              showGutter={true}
              wrapEnabled={true}
              highlightActiveLine={false}
              value={curlCommand}
              readOnly={true}
              fontSize={14}
              setOptions={{
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false,
                enableSnippets: false,
                showLineNumbers: true,
                tabSize: 2,
              }}
            />
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ApiCurlExpandedDialog;
